import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OneSignal } from 'onesignal-ngx';
import { take } from 'rxjs';
import { DbService } from './db.service';
import { Members } from 'src/app/models/members';

const USER_APP_ID = '3fd759ea-61c7-4929-9f19-c4884cdbb13a';
const USER_ANDROID_CHANNEL_ID = '45d13582-2b48-4380-8ebd-69382e5e4c8d';
const oneSignalKey = 'os_v2_app_h7lvt2tby5esthyzyseezw5rhj4z4a3hwatuxmewheynuqyvjzunu7bkqrw5gexods7vn6ifgzsxy7pauveaayz4vlciokrsaz2o2ty';

@Injectable({
  providedIn: 'root',
})
export class PushService {
  constructor(private oneSignal: OneSignal, private httpClient: HttpClient, private db: DbService) { }

  // 알림내역에 쌓이지 않음
  sendPush(pushId: Array<string>, data?: any) {
    console.log('aaa', data);
    console.log('Push IDs:', pushId);

    return new Promise<any>((resolve, reject) => {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json; charset=utf-8',
          'Authorization': `Basic ${oneSignalKey}`,
        }),
      };
      let body = {
        //push 정보
        app_id: USER_APP_ID,
        headings: { en: 'TOMSS' },
        contents: { en: data.content },
        // data: { url: data.url, type: data.type },
        data: { url: data.url },
        include_player_ids: pushId,
        android_channel_id: USER_ANDROID_CHANNEL_ID,
        ios_badgeType: 'Increase',
        ios_badgeCount: 1,
      };
      if (pushId.length > 0) {
        // OneSignal API 호출
        this.httpClient.post('https://onesignal.com/api/v1/notifications', body, httpOptions).subscribe(
          (response) => {
            console.log('Push notification sent successfully:', response);
            resolve(response);
          },
          (error) => {
            console.error('Error sending push notification:', error);
            reject(error);
          }
        );
      } else {
        console.warn('No valid push IDs provided.');
        reject('No valid push IDs provided.');
      }
    });
  }

  // 회원에게 push와 알림 보내기
  memberPush(obj, uuid) {
    this.db
      .collection$(`members`, ref => ref.where('exitSwitch', '==', false).where('uuid', '==', uuid))
      .pipe(take(1))
      .subscribe(async (datas: Members[]) => {
        if (datas && datas.length > 0) {
          for await (let ele of datas) {
            if (ele.pushId.length > 0) {
              this.sendPush(ele.pushId, obj);
              console.log(obj);
              await this.db.updateAt(`notifications/${obj.id}`, obj);
            }
          }
        }
      });
  }

  // getId() {
  //   return new Promise((resolve, reject) => {
  //     this.oneSignal.getUserId().then(playerId => {
  //       resolve(playerId);
  //     });
  //   });
  // }
}
